import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { LogoAr, WhatsIconBtn } from '../../ui/AllImages'
import { trackSnapEvent, trackSnapWhatsAppClick, trackTikTok } from '../../services/snapPixel'

// صفحة عرض الخزائن 550 — وجهة إعلانات سناب. نصوصها مطابقة للإعلان حرفياً
// («احصل على المتر فقط بـ 550 ﷼ شامل التركيب والإنارة» · «عرض حصري لمدة شهر»).
// لا تحويل تلقائي لواتساب: العميل يضغط الزر بنفسه. كلمة «(سناب)» في الرسالة
// تخلي فريق صولا يعدّ عملاء سناب.
const PHONE = '966560532519'
const PHONE_LOCAL = '0560532519'
// رسالة الواتساب تكشف مصدر العميل لفريق صولا حسب utm_source: تيك توك / قوقل / سناب (الافتراضي)
const SOURCE = ((typeof window !== 'undefined' && /utm_source=([^&]+)/i.exec(window.location.search)) || [])[1] || ''
const WA_MESSAGE = /^tiktok/i.test(SOURCE) ? 'شفت اعلانكم على تيكتوك - أبغى عرض الخزائن 550'
    : /^google/i.test(SOURCE) ? 'شفت اعلانكم في قوقل - أبغى عرض الخزائن 550'
    : 'أبغى عرض الخزائن 550 (سناب)'
const WA_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(WA_MESSAGE)}`

const FEATURES = [
    'خشب مقاوم للرطوبة والخدش',
    'خزائن بتفاصيل عالمية',
    'مفصلات إيطالية سوفت كلوز',
    'إنارة مدمجة — شاملة في السعر',
    'أناقة التصاميم الحديثة بدقة',
    'تصميم يبدأ من فكرتك',
]

const GALLERY = ['g1', 'g2', 'g3', 'g4', 'g5', 'g6']

const WhatsAppButton = ({ source, children, className }) => (
    <a className={`btn-wa ${className || ''}`} href={WA_URL} onClick={() => trackSnapWhatsAppClick(source)}>
        <WhatsIconBtn />
        <span>{children}</span>
    </a>
)

// نقرات tel: يلتقطها مستمع App.jsx العام (CUSTOM_EVENT_2 + SIGN_UP)
const CallButton = ({ children, className }) => (
    <a className={`btn-call ${className || ''}`} href={`tel:+${PHONE}`}>
        <span>{children}</span>
    </a>
)

const Wardrobes550 = () => {
    useEffect(() => {
        document.title = 'عرض خزائن صولا — المتر بـ 550 ﷼ شامل التركيب والإنارة'
        trackSnapEvent('VIEW_CONTENT', { item_category: 'wardrobes_550' })
        trackTikTok('ViewContent', { content_name: 'wardrobes_550' })
    }, [])

    return (
        <Page dir="rtl" lang="ar">
            <header className="topbar">
                <Link to="/" className="logo" aria-label="صولا"><LogoAr /></Link>
                <CallButton className="topcall">اتصل الآن</CallButton>
            </header>

            <section className="hero">
                <div className="hero-text">
                    <span className="eyebrow">عرض صولا الحصري</span>
                    <h1>خزائن صولا<br />المتر فقط بـ <b>550 ﷼</b></h1>
                    <p className="incl">شامل التركيب والإنارة</p>
                    <span className="chip">عرض حصري لمدة شهر</span>
                    <div className="ctas">
                        <WhatsAppButton source="offer550_hero">أبغى عرض الخزائن 550</WhatsAppButton>
                        <CallButton>اتصل: {PHONE_LOCAL}</CallButton>
                    </div>
                </div>
                <div className="hero-media">
                    <video src="/offer/w550.mp4" poster="/offer/w550-poster.jpg" autoPlay muted loop playsInline preload="metadata" />
                </div>
            </section>

            <section className="features">
                <h2>ليش خزائن صولا؟</h2>
                <ul>
                    {FEATURES.map((f) => <li key={f}><i aria-hidden="true">✓</i>{f}</li>)}
                </ul>
            </section>

            <section className="gallery">
                <h2>من أعمالنا</h2>
                <div className="grid">
                    {GALLERY.map((g) => <img key={g} src={`/offer/${g}.jpg`} alt="خزائن صولا" loading="lazy" />)}
                </div>
            </section>

            <section className="final">
                <h2>احجز عرضك قبل انتهاء المدة</h2>
                <p>المتر فقط بـ 550 ﷼ شامل التركيب والإنارة — عرض حصري لمدة شهر</p>
                <div className="ctas">
                    <WhatsAppButton source="offer550_final">راسلنا على واتساب</WhatsAppButton>
                    <CallButton>اتصل: {PHONE_LOCAL}</CallButton>
                </div>
            </section>

            <footer className="foot">
                <p><b>مؤسسة صولا للديكور</b></p>
                <p>حي المونسية - شارع الصحابة - مبنى رقم 6654 - الرياض</p>
                <p className="links"><Link to="/">الموقع الرئيسي</Link> · <Link to="/privacy">سياسة الخصوصية</Link></p>
            </footer>

            <div className="sticky">
                <WhatsAppButton source="offer550_sticky">واتساب</WhatsAppButton>
                <CallButton>اتصال</CallButton>
            </div>
        </Page>
    )
}

const Page = styled.div`
    --brand: var(--themeColor, #CE6605);
    --dark: var(--secondaryColor, #521501);
    --cream: var(--bg, #F8F2E6);
    --wa: #25D366;
    font-family: var(--arRegular), Tahoma, sans-serif;
    background: var(--cream);
    color: #2b1a10;
    min-height: 100vh;
    padding-bottom: 84px;
    text-align: right;
    h1, h2, b { font-family: var(--arBold), Tahoma, sans-serif; }

    .topbar {
        display: flex; align-items: center; justify-content: space-between;
        padding: 12px 16px; background: #fff; border-bottom: 1px solid var(--stroke, #D6C3AB);
        position: sticky; top: 0; z-index: 20;
        .logo svg { height: 40px; width: auto; }
    }
    a { text-decoration: none; }
    .btn-wa, .btn-call {
        display: inline-flex; align-items: center; justify-content: center; gap: 8px;
        min-height: 52px; padding: 0 22px; border-radius: 12px; font-size: 18px;
        font-family: var(--arBold), Tahoma, sans-serif; transition: transform .1s;
        &:active { transform: scale(.98); }
    }
    .btn-wa { background: var(--wa); color: #fff; svg { width: 22px; height: 22px; } }
    .btn-call { background: #fff; color: var(--dark); border: 2px solid var(--dark); }
    .topcall { min-height: 40px; padding: 0 14px; font-size: 15px; }

    .hero {
        display: grid; grid-template-columns: 1fr; gap: 20px;
        max-width: 1100px; margin: 0 auto; padding: 20px 16px 8px;
    }
    .eyebrow { color: var(--brand); font-size: 16px; }
    h1 { font-size: 34px; line-height: 1.35; margin: 6px 0 4px; color: var(--dark);
        b { color: var(--brand); font-size: 44px; white-space: nowrap; } }
    .incl { font-size: 20px; margin: 0 0 10px; }
    .chip { display: inline-block; background: var(--dark); color: #fff; padding: 6px 14px; border-radius: 999px; font-size: 15px; }
    .ctas { display: flex; flex-direction: column; gap: 10px; margin-top: 18px; }
    .hero-media video {
        width: 100%; max-height: 72vh; object-fit: cover; border-radius: 16px; background: #000; display: block;
    }

    section h2 { font-size: 24px; color: var(--dark); margin: 0 0 14px; }
    .features, .gallery, .final { max-width: 1100px; margin: 0 auto; padding: 24px 16px; }
    .features ul { list-style: none; padding: 0; margin: 0; display: grid; gap: 10px; }
    .features li { background: #fff; border-radius: 12px; padding: 14px 16px; font-size: 17px; display: flex; gap: 10px; align-items: center;
        i { font-style: normal; color: #fff; background: var(--brand); width: 26px; height: 26px; border-radius: 50%;
            display: inline-flex; align-items: center; justify-content: center; flex: none; font-size: 14px; } }
    .gallery .grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;
        img { width: 100%; aspect-ratio: 9 / 16; object-fit: cover; border-radius: 12px; display: block; } }
    .final { text-align: center; background: #fff; border-radius: 16px; margin: 12px 16px; max-width: 1068px;
        p { font-size: 17px; } .ctas { align-items: stretch; } }
    .foot { text-align: center; padding: 24px 16px 8px; font-size: 14px; color: #6b5444;
        p { margin: 4px 0; } a { color: var(--dark); text-decoration: underline; } }

    .sticky {
        position: fixed; bottom: 0; left: 0; right: 0; z-index: 30; display: grid; grid-template-columns: 2fr 1fr; gap: 8px;
        padding: 10px 12px calc(10px + env(safe-area-inset-bottom)); background: rgba(255,255,255,.96);
        box-shadow: 0 -4px 16px rgba(0,0,0,.08);
        .btn-wa, .btn-call { min-height: 50px; padding: 0 10px; }
    }

    @media (min-width: 768px) {
        padding-bottom: 0;
        .hero { grid-template-columns: 1.1fr .9fr; align-items: center; padding-top: 40px; }
        h1 { font-size: 46px; b { font-size: 60px; } }
        .ctas { flex-direction: row; flex-wrap: wrap; }
        .features ul { grid-template-columns: repeat(3, 1fr); }
        .gallery .grid { grid-template-columns: repeat(6, 1fr); }
        .final { margin: 12px auto; .ctas { justify-content: center; } }
        .sticky { display: none; }
    }
`

export default Wardrobes550
